import BrandProgress from './BrandProgress';

/**
 * Drop-in replacement for react-bootstrap's <Spinner>, so every data loader in the web app
 * carries the Link my Food brand without touching each call site.
 *
 *   size="sm"   a compact orange ring with the same circling arc (for buttons and inline text);
 *               inside a .btn it takes the button's text colour so it stays readable.
 *   otherwise   the full round badge loader, sized to a section (default 56 px).
 *
 * Props mirror <Spinner>: `size`, `role`, `as`, `className`, `style`, `children`. `animation`
 * and `variant` are accepted and ignored (the brand loader has one style).
 */
export default function BrandSpinner({ size, role, as: Tag = 'span', className = '', style, children, label = 'Loading' }) {
  if (size === 'sm') {
    return (
      <Tag className={`bring ${className}`.trim()} role={role} aria-hidden={role ? undefined : true} style={style}>
        {children ? <span className="visually-hidden">{children}</span> : null}
      </Tag>
    );
  }
  return (
    <span className={`bprog-bare-wrap ${className}`.trim()} style={style}>
      <BrandProgress variant="bare" label={typeof children === 'string' ? children : label} size={56} />
    </span>
  );
}
